import { combineReducers } from 'redux';
import TravellerDetails from './slices/TravellerDetailsSlice';
import QuoteDetails from './slices/QuoteDetailsSlice';
import MastersData from './slices/MastersDataSlice';
import Enquiry from './slices/EnquirySlice';

const rootReducer = combineReducers({
    TravellerDetails,
    QuoteDetails,
    MastersData,
    Enquiry,

});

export default rootReducer;
